export default __webpack_public_path__ + "static/media/flag-ko.90d1da05.svg";